import React from "react";
import { Footer } from "./footer";
import { Header } from "./header";

export function MainView(props: { children: JSX.Element | JSX.Element[] }) {
  return (
    <div>
      <Header />
      <main>{props.children}</main>
      <Footer />
    </div>
  );
}
